// extracted by css-extract-rspack-plugin
export default {"page-content":"page-content-_DhQ67","pageContent":"page-content-_DhQ67"};